export const flyToCoords = (x, y, zoom=10, padding=false, duration=3000, view) => {
  // This is a hack. We were using "flyTo" but that doesn't allow you to pass in
  // padding, which we need to account for the sidebar
  let bounds = [[x,y], [x,y], [x,y], [x,y], [x,y]];
  padding = {top: 50, bottom: 50, left: 370, right: 50};
  if(window.innerWidth < 700){
    padding = {top: 100, bottom: window.innerHeight * .4 + 40, left: 20, right: 20};
  }
  if(view === 'detail'){
    padding = {top: 50, bottom: 50, left: 50, right: 50}
  }
  window.fireMap.fitBounds(bounds, {
    padding: padding,
    duration: duration,
    maxZoom: zoom
  });
};

export const flyToBbox = (bbox, duration=3000, view) => {
  let bounds = bbox.reduce((bounds, coord) => {
        return bounds.extend(coord);
    }, new mapboxgl.LngLatBounds(bbox[0], bbox[0]));
  let padding = {top: 50, bottom: 50, left: 370, right: 50};
  if(window.innerWidth < 700){
    padding = {top: 100, bottom: window.innerHeight * .4 + 40, left: 20, right: 20};
  }
  if(view === 'detail'){
    padding = {top: 130, bottom: 50, left: 50, right: 50}
  }
  window.fireMap.fitBounds(bounds, {
      padding: padding,
      duration: duration
  });
}
